import React, { useEffect, useState } from 'react'
import TopNavigation from '../Components/navigation/TopNavigation'
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import bannerHero from './../assets/nevels2.png';
import { Link } from 'react-router-dom';
import MainFooter from '../Components/footer/MainFooter';
import { Helmet } from 'react-helmet';
import CreateAnnisite from '../Components/modals/CreateAnnisite';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

function Annisites() {
    const [page, setPage]                                                 = useState(1);
    const [processing, setProcessing]                                     = useState(false);

    const [createAnnisite, setCreateAnnisite]                             = useState([]);
    const [listOfAnnisites, setListOfAnnisites]                           = useState([]);

    const {user}                                                          = useSelector((state) => state.auth);

    const [memoryList, setMemoryList]                                     = useState([]);

    const [selectedMigrateID, setSelectedMigrateID]                       = useState("");
    const [showModal, setShowModal]                                       = useState(false);
    const amountFigure = "400.00";

    useEffect(() => {
        handleAnnivitesCollectionList()
    },[])

    const handleAnnivitesCollectionList = async () => {
        try{
            setProcessing(true);
            const responseAnny = await axios.get(CONSTANTS.API_URL +"annivites/list/v2/onvite/" + page);
            
            setListOfAnnisites(responseAnny.data);
            setProcessing(false);
        }catch(errors){
            console.log(errors);
            setProcessing(false);
        }
    }

     const handlePayFastNow = async () => {
      try {
        
         const cartOnvite ={ 
               "amount": amountFigure,               
               "item_name": "Onvite - Wedding Invite",               
               "name_first" : user.name,
               "name_last" : user.surname,
               "email_address" : user.email,
            };  

        const resData = await axios.post(CONSTANTS.URL_HOME +"payfast/process/api.php", cartOnvite, {
                      headers: { 
                          'token': 'Bearer ' + user.accessToken
                    }
                  });
        
     
        if (resData.data.payfast_url) {
              window.location.href = resData.data.payfast_url;
          } else {
              toast.warning('Error: PayFast URL not received from backend.');
          }
      } catch (err) {
        console.error("Payment Error:", err);
        toast.error("Something went wrong. Please try again later.")
      }
  };
  return (
    <div className="main-layer">
        <Helmet>
           <title>Lovedripp - Annisites</title>
        </Helmet>
        <TopNavigation title={"Annisites"} classBack="full-white"/>
        <div className="content-layer">
             <div className="banner-photo-show middle-align txt-white" 
                  style={{backgroundImage: `url("${bannerHero}")`}}>     
                  <div className="info-hero-intro">
                     <h1 className="head-styling-font">Welcome to our Annisites</h1>
                     <div className="sub-text-hero">
                      Our list of special anniversaries collected for luxurious displays that we refer to as <strong>annisites</strong>  
                     </div>
                  </div>                 
              </div>
              <div className="section-item">
                <div className="container">
                  <h2 className="text-center ">Our Anniversaries</h2>
                 
                  <div className="row">
                      {
                        listOfAnnisites &&
                        listOfAnnisites.length > 0 && (
                        listOfAnnisites.map((annisite, index) => {
                            return <div className="col-md-3" key={index}>
                                      <Link to={"/couple-event/" + annisite._id}
                                        className="card-frame">
                                        <div className="photoframe">
                                          <div className="image-photo"
                                            style={{backgroundImage: `url("${annisite.featureUrl}")`}}>
                                          </div>
                                          <div className="phrame-content">
                                            <h3>{annisite.spouseA} & {annisite.spouseB}</h3> 
                                            <div className="event-date">{annisite.weddingDate}</div>
                                          </div>
                                        </div>   
                                      </Link>                              
                                      
                                  </div>
                          })
                        )
                      }
                  </div>
                </div>
              </div>
        </div>
       {
              processing && (
                  <div className="processing-spinner">
                          <img src={CONSTANTS.SMALL_PROCESSING} className="pro-spin" />
                  </div>
              )
        }
        <MainFooter />
    </div>
  )
}

export default Annisites